export default "__VITE_ASSET__CUoBiSGv__"